<template>
  <div class="popularize_container">
    <swiper
      :modules="modules"
      :slidesPerView="1"
      :centeredSlides="true"
      loop
      autoplay
      :spaceBetween="0"
      class="banner_wrapper"
      :pagination="pagination"
    >
      <swiper-slide v-for="(item, index) in swiperData" :key="index" @click="skipHandle(item)">
        <img :src="item.dataImgUrl" class="banner_img" />
      </swiper-slide>
    </swiper>

    <div class="tag_wrapper">
      <span class="tag_text">{{ $t('advert') }}</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay, Pagination } from 'swiper'
import { LmsDecorateModule } from '@/api/Models/HomeConfig'
import { useThemeColor } from '@/utils/theme'
import { useRouter } from 'vue-router'
import { handleExternalUrl } from '@/utils/navigation'

const modules = [Autoplay, Pagination]
const props = defineProps<{
  data: LmsDecorateModule
}>()

const router = useRouter()
interface TSwiperItem {
  dataJumpType: number
  dataJumpUrl: string
  dataJumpId: string
  dataJumpName: string
}
const skipHandle = (item: TSwiperItem) => {
  switch (item.dataJumpType) {
    case 1: // 课程
      router.push({
        name: 'courseDetail',
        query: {
          id: item.dataJumpId,
          courseId: '',
          endingType: 0,
          channel: 1,
          courseType: 'course'
        }
      })
      break
    case 2: // 课件
      router.push({
        name: 'courseDetail',
        query: {
          id: item.dataJumpId,
          courseId: '',
          endingType: 0,
          channel: 1,
          courseType: 'courseWare'
        }
      })
      break
    case 3: // 链接
      // router.push('/webview?url=' + encodeURIComponent(item.dataJumpUrl))
      handleExternalUrl({ jumpUrl: item.dataJumpUrl })
      break
    case 4: // 资讯
      router.push('/broadcastDetail/' + item.dataJumpId)
      break
    case 5: // 培训
      router.push('/trainingDetail?id=' + item.dataJumpId)
      break
    case 6: // 考试
      router.push('/examInfo?examId=' + item.dataJumpId)
      break
    case 7: // 调查
      router.push('/surveyInfo?investigationId=' + item.dataJumpId)
      break
    case 8: // 直通车
      router.push('/ceo')
      break
    default:
      break
  }
}

const swiperData = computed(() => {
  try {
    // console.log(JSON.parse(props.data.lmsDecorateModuleCategories[0].datas[0].json))
    return JSON.parse(props.data.lmsDecorateModuleCategories[0].datas[0].json)
  } catch (error) {
    return []
  }
})

const themeColor = useThemeColor()
const pagination = {
  clickable: true,
  renderBullet(index: number, className: string) {
    return '<span class="' + className + '"></span>'
  }
}
</script>

<style lang="less" scoped>
@import url('@/styles/variables.less');
.popularize_container {
  position: relative;
  .tag_wrapper {
    position: absolute;
    top: 5px;
    right: 20px;
    border-radius: 3px;
    padding: 2px 3px;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 2;
    .tag_text {
      font-size: 14px;
      color: @textWhite;
    }
  }
  .banner_wrapper {
    margin: 12px 16px;
    width: calc(100vw - 32px);
    height: calc((100vw - 32px) * 0.408);
  }

  .banner_img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
  }
}

:deep(.swiper-pagination) {
  position: absolute;
  bottom: 12px;
  left: 12px;
  z-index: 10;
  display: flex;
  align-items: center;
}
:deep(.swiper-pagination-bullet) {
  width: 8px;
  height: 2px;
  background: #ffffff;
  border-radius: 1px;
  margin-right: 4px;
}
:deep(.swiper-pagination-bullet-active) {
  height: 3px;
  background: v-bind(themeColor);
}
</style>
